// extracted by mini-css-extract-plugin
module.exports = {"toast":"Toast_toast__XYf5p","slot":"Toast_slot__cLgMs"};